// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'

type Props = {
  items: Array<[string, string]>,
  clickHandler: (
    selectedKey: string,
    event: SyntheticEvent<HTMLAnchorElement>
  ) => void,
  activeItem: string
}

export function SelectionList ({
  items,
  clickHandler,
  activeItem
}: Props): React.Element<'div'> {
  return (
    <div className='ui labels selection-list'>
      {items.map(item => {
        return (
          <LinkItem
            key={item[0]}
            isActive={activeItem === item[0]}
            clickHandler={(event: SyntheticEvent<HTMLAnchorElement>) =>
              clickHandler(item[0], event)}
            title={item[1]}
          />
        )
      })}
    </div>
  )
}

/**
 * A single link list item.
 * @param title
 * @param clickHandler
 * @param isActive
 * @return {XML}
 * @constructor
 */
function LinkItem ({
  title,
  clickHandler,
  isActive = false
}: {
  title: string,
  clickHandler: (event: SyntheticEvent<HTMLAnchorElement>) => void,
  isActive: boolean
}) {
  return (
    <a
      onClick={clickHandler}
      className={`${isActive
        ? 'active inverted' + ' olive'
        : 'basic'} ui label link-item`}
    >
      {title}
    </a>
  )
}

export default SelectionList
export { LinkItem }
export type { Props as SelectionListProps }
